module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Deposit statement","date":"Date","info":"Info","amount":"Amount","notFound":"No deposit statements"},"et":{"title":"Deposit statement","date":"Date","info":"Info","amount":"Amount","notFound":"No deposit statements"},"ru":{"title":"Deposit statement","date":"Date","info":"Info","amount":"Amount","notFound":"No deposit statements"}}')
  delete Component.options._Ctor
}
